export const blockConstants = {
    SET_BLOCK: 'BLOCK_SET_BLOCK',
    SET_BLOCKS: 'BLOCK_SET_BLOCKS',
    SET_PRODUCT: 'BLOCK_SET_PRODUCT',
};
